import { ParticipationGridColDef } from '../../types';

export const linkedCMGEntityNameColDef: ParticipationGridColDef<string> = {
  field: 'firm.name',
  headerName: 'Linked CMG Investor Name',
  filter: 'agTextColumnFilter',
  floatingFilter: true,
};
